import { IS_TEST, ZEROBOUNCE_API } from '~/utils/constants';

export const options = {
  method: 'GET',
};

export type ZeroBounceResponse = {
  status: string;
  sub_status?: string;
};

export type EmailStatus = 'valid' | 'invalid' | 'do_not_mail' | 'unknown';

export type EmailSubStatus =
  | 'role_based'
  | 'role_based_catch_all'
  | 'global_suppression'
  | 'disposable'
  | 'toxic'
  | 'unknown'
  | 'possible_trap'
  | 'mx_forward'
  | 'antispam_system'
  | 'exception_occurred'
  | 'failed_smtp_connection'
  | 'forcible_disconnect'
  | 'greylisted'
  | 'mail_server_did_not_respond'
  | 'mail_server_temporary_error'
  | 'timeout_exceeded'
  | 'does_not_accept_mail'
  | 'failed_syntax_check'
  | 'possible_typo'
  | 'mailbox_not_found'
  | 'no_dns_entries'
  | 'mailbox_quota_exceeded'
  | 'unroutable_ip_address';

export const fetchData = async (email: string): Promise<ZeroBounceResponse> => {
  const response = !IS_TEST
    ? await fetch(
        `${ZEROBOUNCE_API}?api_key=${process.env.ZEROBOUNCE_API_KEY}&email=${email}`,
        options,
      )
    : null;
  const data = await response?.json();
  return data;
};

export const validateEmailOnRegEx = (email: string, regEx: RegExp): Boolean => {
  return regEx.test(email);
};
